import { Directory, type DirectoryData } from '@ail/shared/directory'
import { DEFAULT_NAMING, menuPrefix as sharedMenuPrefix, operatorFromCampaignName as sharedOperatorFrom, resolvePlatform as sharedResolvePlatform, type NamingRules } from '@ail/shared/naming'

/**
 * 契約プロジェクトの名簿（チーム・運用者）と、キャンペーン名の読み方。
 * 画面の起動時に /api/admin/directory から読み、setDirectory() で差し替える。
 * 各画面はこれまでどおり operatorName() などを呼べばよい。
 */
export type TeamKey = string

let dir = new Directory()
let naming: NamingRules = DEFAULT_NAMING

/** 名前で引ける表（中身は契約が変わるたびに入れ替える）。 */
export const OPERATOR_NAMES: Record<string, string> = {}
export const SELECTABLE_OPERATOR_CODES: string[] = []
export const TEAM_OPTIONS: Array<{ key: TeamKey; label: string }> = []

export function setDirectory(data: DirectoryData, rules?: NamingRules | null): void {
  dir = new Directory(data)
  naming = rules ?? DEFAULT_NAMING
  for (const k of Object.keys(OPERATOR_NAMES)) delete OPERATOR_NAMES[k]
  for (const o of dir.operators) OPERATOR_NAMES[o.code] = o.name
  SELECTABLE_OPERATOR_CODES.splice(0, SELECTABLE_OPERATOR_CODES.length, ...dir.selectableCodes())
  TEAM_OPTIONS.splice(0, TEAM_OPTIONS.length, ...dir.teams.map((t) => ({ key: t.key, label: t.label })))
}

export function currentDirectory(): Directory {
  return dir
}

export function currentNaming(): NamingRules {
  return naming
}

export function operatorName(code?: string | null): string {
  return dir.operatorName(code)
}

export function operatorTeam(code?: string | null): TeamKey {
  return dir.operatorTeam(code)
}

export function teamLabel(key: TeamKey): string {
  return dir.teamLabel(key)
}

export function teamLabelForOperator(code?: string | null): string {
  return dir.teamLabelForOperator(code)
}

/** このコードを選んだ時に数に入れるコード（まとめて持つ相手も含む）。 */
export function operatorAliases(code: string): string[] {
  return dir.aliases(code)
}

export function operatorFromCampaignName(name?: string | null): string {
  return sharedOperatorFrom(name, dir.knownCodes(), naming)
}

export type Platform = 'meta' | 'tiktok' | 'google'

export function resolvePlatform(campaignName?: string | null, platform?: string | null, accountName?: string | null): Platform {
  return sharedResolvePlatform(campaignName, platform, accountName)
}

export function menuPrefix(name?: string | null, menu?: string | null): string | null {
  return sharedMenuPrefix(name, menu, naming)
}

/** KPI の色の目安。 */
export const CPA_WARN = 15000
export const CPA_DANGER = 18000
